import { createCarousel } from "@/ui/carousel/carousel";
import { startViewTransition } from "@/utils/dom";
import { createContentSection } from "../content-section/content-section";
import "./section-pricing.css";

export const createSectionPricing = () => {
  const container = document.querySelector<HTMLElement>(
    ".carousel.pricing-cards",
  );

  if (container !== null) {
    createCarousel(container, {
      breakpoints: {
        "(width >= 1440px)": {
          active: false,
        },
      },
    });
  }

  createContentSection();

  const comparison = document.querySelector(".pricing-comparison");

  const expandBtn = comparison?.querySelector(".expand-btn");

  const periodSwitchInput = comparison?.querySelector<HTMLInputElement>(
    ".period-switch input",
  );

  periodSwitchInput?.addEventListener("input", (event) => {
    const input = event.currentTarget as HTMLInputElement;
    const checked = input.checked;

    startViewTransition(
      () => {
        comparison?.classList.toggle("is-monthly", checked === false);
        comparison?.classList.toggle("is-yearly", checked === true);
      },
      {
        types: ["pricing-period"],
      },
    );
  });

  expandBtn?.addEventListener("click", () => {
    startViewTransition(
      () => {
        comparison?.classList.toggle("is-expanded");
      },
      {
        types: ["pricing-comparison-expand"],
      },
    );
  });
};
